import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import { App } from "./App.tsx";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-loading-skeleton/dist/skeleton.css";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import "./styles/loyalty-points.css"

import { Provider } from "react-redux";
import { store } from "./store";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import {
  ShippingProvider,
  PaymentProvider,
  OrderProvider,
  LoyaltyProvider,
  LayoutProvider,
  GiftcardProvider,
} from "./context";
import { ToastContainer } from "react-toastify";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

const TOAST_AUTOCLOSE_TIME = import.meta.env.VITE_TOAST_AUTOCLOSE_TIME;
const GOOGLE_API_CLIENT_ID = import.meta.env.VITE_GOOGLE_API_CLIENT_ID;
const STRIPE_CLIENT_ID = import.meta.env.VITE_STRIPE_CLIENT_ID;
const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;
const stripePromise = loadStripe(STRIPE_CLIENT_ID);

Sentry.init({
  // dsn: "https://7401171c7326561873e5400ecda24e30@o44657.ingest.us.sentry.io/4509670949388288",
  dsn: SENTRY_DSN,
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
});

const queryClient = new QueryClient({});
ReactDOM.createRoot(document.getElementById("root")!).render(
  <GoogleOAuthProvider clientId={GOOGLE_API_CLIENT_ID}>
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <Sentry.ErrorBoundary>
          <Provider store={store}>
            <LayoutProvider>
              {/* <StoreProvider> */}
              {/* <AuthProvider> */}
              <LoyaltyProvider>
                {/* <OrderOptionProvider> */}
                {/* <CartProvider> */}
                <ShippingProvider>
                  <PaymentProvider>
                    <GiftcardProvider>
                    <OrderProvider>
                      <Elements stripe={stripePromise}>
                        <App />
                      </Elements>
                      <ToastContainer
                        position="top-right"
                        autoClose={TOAST_AUTOCLOSE_TIME}
                        hideProgressBar={true}
                        newestOnTop={true}
                        closeOnClick={true}
                        stacked
                        draggable
                        pauseOnHover
                      />
                    </OrderProvider>
                    </GiftcardProvider>
                  </PaymentProvider>
                </ShippingProvider>
                {/* </CartProvider> */}
                {/* </OrderOptionProvider> */}
              </LoyaltyProvider>
              {/* </AuthProvider> */}
              {/* </StoreProvider> */}
            </LayoutProvider>
          </Provider>
        </Sentry.ErrorBoundary>
      </QueryClientProvider>
    </React.StrictMode>
  </GoogleOAuthProvider>,
);
